export const siteInfo = {
  name: "黄桃视频",
  slogan: "不缓冲 · 不卡顿 · 极速高清",
  intro: "黄桃视频致力于打造新一代高清在线播放体验，专注提供91视频与97视频同级别的高品质影视内容。每日更新海量电影、电视剧、综艺、动漫资源，全站采用极速CDN节点分发，确保您在任何网络环境下都能享受不缓冲、不卡顿的流畅观影体验。我们持续优化播放引擎，支持多清晰度自适应切换，从标清到超清一应俱全。",
  stats: [
    { label: "每日更新", value: "200+ 部" },
    { label: "高清覆盖率", value: "98%" },
    { label: "平均加载", value: "< 1 秒" },
  ],
  navLinks: [
    { label: "首页", href: "#hero" },
    { label: "热门话题", href: "#topics" },
    { label: "焦点专题", href: "#carousel" },
    { label: "精选推荐", href: "#cards" },
    { label: "主题索引", href: "#index" },
  ],
};

export const mediaItems = [
  {
    id: 1,
    title: "暑期档爆款《逆袭人生》高清完整版上线",
    category: "电影",
    duration: "02:18:45",
    quality: "4K",
    heat: "987万播放",
    image: "https://readdy.ai/api/search-image?query=dramatic%20movie%20poster%20with%20warm%20golden%20lighting%20and%20cinematic%20composition%2C%20modern%20Chinese%20film%20aesthetic%2C%20emotional%20protagonist%20silhouette%20against%20city%20skyline%2C%20rich%20contrast%20and%20deep%20shadows&width=400&height=600&seq=media-ht-01&orientation=portrait",
  },
  {
    id: 2,
    title: "热播剧《长安十二时辰》第二季独家上线",
    category: "电视剧",
    duration: "45集全",
    quality: "1080P",
    heat: "1.2亿播放",
    image: "https://readdy.ai/api/search-image?query=historical%20Chinese%20drama%20scene%20with%20ancient%20Tang%20dynasty%20palace%20architecture%2C%20warm%20lantern%20lighting%2C%20mysterious%20atmosphere%2C%20rich%20red%20and%20gold%20color%20palette%2C%20cinematic%20quality&width=400&height=600&seq=media-ht-02&orientation=portrait",
  },
  {
    id: 3,
    title: "《歌手2026》总决赛之夜全场回放",
    category: "综艺",
    duration: "03:45:20",
    quality: "4K",
    heat: "2.3亿播放",
    image: "https://readdy.ai/api/search-image?query=grand%20music%20competition%20stage%20with%20dramatic%20spotlight%20and%20stunning%20stage%20design%2C%20enthusiastic%20audience%20silhouettes%2C%20concert%20atmosphere%2C%20warm%20golden%20stage%20lighting&width=400&height=600&seq=media-ht-03&orientation=portrait",
  },
  {
    id: 4,
    title: "国产科幻巨制《流浪地球3》院线同步上线",
    category: "电影",
    duration: "02:32:10",
    quality: "4K HDR",
    heat: "5.6亿播放",
    image: "https://readdy.ai/api/search-image?query=epic%20sci-fi%20movie%20scene%20with%20massive%20space%20station%20and%20Earth%20in%20background%2C%20dramatic%20cosmic%20lighting%2C%20technological%20aesthetic%2C%20warm%20orange%20thruster%20glow%20against%20dark%20space&width=400&height=600&seq=media-ht-04&orientation=portrait",
  },
  {
    id: 5,
    title: "纪录片《舌尖上的中国》第五季全集",
    category: "纪录片",
    duration: "12集全",
    quality: "4K",
    heat: "8900万播放",
    image: "https://readdy.ai/api/search-image?query=beautiful%20Chinese%20cuisine%20close-up%20photography%20with%20steaming%20hot%20food%20and%20warm%20natural%20lighting%2C%20traditional%20kitchen%20setting%2C%20rich%20textures%20and%20colors%2C%20appetizing%20food%20documentary%20style&width=400&height=600&seq=media-ht-05&orientation=portrait",
  },
];

export const contactInfo = {
  title: "投稿与合作",
  description: "欢迎优质内容创作者加入黄桃视频，共享高清流畅的播放体验。无论您是独立影视制作人、短视频创作者还是媒体机构，我们都为您提供专业的内容分发与流量支持。",
  cta: "联系我们",
  email: "contact@huangtao.video",
  services: [
    "内容投稿", "版权合作", "广告投放", "API接入",
  ],
};

export const topicItems = [
  { id: 1, name: "暑期档推荐", heat: "3.2万讨论", color: "accent" },
  { id: 2, name: "高分华语片", heat: "2.8万讨论", color: "primary" },
  { id: 3, name: "4K专区", heat: "1.9万讨论", color: "secondary" },
  { id: 4, name: "新片速递", heat: "4.1万讨论", color: "accent" },
  { id: 5, name: "经典回顾", heat: "1.5万讨论", color: "primary" },
  { id: 6, name: "综艺热播", heat: "2.6万讨论", color: "secondary" },
  { id: 7, name: "纪录片精选", heat: "9800讨论", color: "accent" },
  { id: 8, name: "动漫新番", heat: "3.7万讨论", color: "primary" },
  { id: 9, name: "午夜剧场", heat: "1.2万讨论", color: "secondary" },
];

export const cardItems = [
  {
    id: 1,
    title: "黄桃视频播放引擎全面升级：智能预加载技术让等待成为历史",
    excerpt: "全新一代播放器内核上线，基于AI预测算法实现毫秒级缓冲响应，4K视频也能秒开不卡顿…",
    tag: "平台动态",
    date: "2026-07-30",
    image: "https://readdy.ai/api/search-image?query=modern%20video%20player%20interface%20design%20with%20sleek%20dark%20theme%2C%20play%20button%20and%20progress%20bar%2C%20clean%20minimalist%20tech%20aesthetic%2C%20warm%20accent%20highlights%20on%20dark%20background&width=600&height=375&seq=card-ht-01&orientation=landscape",
  },
  {
    id: 2,
    title: "《繁花》导演剪辑版：三小时未删减完整呈现上海滩风云",
    excerpt: "王家卫导演亲自操刀，新增30分钟独家内容，黄桃视频全网首发高清修复版…",
    tag: "独家内容",
    date: "2026-07-28",
    image: "https://readdy.ai/api/search-image?query=cinematic%20Shanghai%20cityscape%20in%20golden%20hour%20light%2C%20vintage%20aesthetic%20with%20modern%20touch%2C%20riverside%20buildings%20with%20warm%20glow%2C%20elegant%20and%20nostalgic%20atmosphere&width=600&height=375&seq=card-ht-02&orientation=landscape",
  },
  {
    id: 3,
    title: "暑期片单大盘点：这十部国产电影口碑炸裂值得二刷",
    excerpt: "从悬疑到喜剧，从科幻到文艺，黄桃编辑部精心挑选今夏最值得观看的华语佳作…",
    tag: "编辑推荐",
    date: "2026-07-25",
    image: "https://readdy.ai/api/search-image?query=collection%20of%20movie%20posters%20arranged%20artistically%20on%20a%20warm%20colored%20wall%2C%20cinema%20aesthetic%2C%20soft%20gallery%20lighting%2C%20diverse%20film%20genres%20represented&width=600&height=375&seq=card-ht-03&orientation=landscape",
  },
  {
    id: 4,
    title: "动漫迷福音：七月新番独家上线黄桃视频，追番不等待",
    excerpt: "本季度最受期待的多部日本新番国内版权已确认，同步更新，中文字幕完整版…",
    tag: "动漫速报",
    date: "2026-07-22",
    image: "https://readdy.ai/api/search-image?query=colorful%20anime%20style%20illustration%20with%20vibrant%20characters%20against%20urban%20Japanese%20cityscape%2C%20dynamic%20composition%2C%20warm%20sunset%20lighting%2C%20modern%20animation%20aesthetic&width=400&height=250&seq=card-ht-04&orientation=landscape",
  },
  {
    id: 5,
    title: "黄桃视频开放平台上线：内容创作者一键分发，收益透明",
    excerpt: "全新的创作者服务平台正式对外开放，提供数据分析、收益管理、粉丝互动等一站式工具…",
    tag: "产品更新",
    date: "2026-07-18",
    image: "https://readdy.ai/api/search-image?query=clean%20modern%20dashboard%20interface%20with%20data%20charts%20and%20analytics%2C%20creator%20platform%20design%2C%20dark%20theme%20with%20orange%20accent%20highlights%2C%20professional%20tech%20aesthetic&width=400&height=250&seq=card-ht-05&orientation=landscape",
  },
];

export const faqItems = [
  {
    id: 1,
    question: "黄桃视频需要付费观看吗？",
    answer: "黄桃视频目前提供完全免费的在线播放服务。您无需注册或付费即可观看全站所有高清影视内容。我们通过广告合作维持平台运营，确保用户享受不缓冲、不卡顿的高清流畅体验。未来如推出会员增值服务，会提前公告并保留免费基础服务。",
  },
  {
    id: 2,
    question: "为什么黄桃视频播放比91视频和97视频更流畅？",
    answer: "黄桃视频采用自研智能CDN分发系统，在全国部署超过200个加速节点，并搭载AI预加载引擎。系统会根据您的网络环境自动选择最优节点，并提前缓存即将播放的内容片段，实现真正的零缓冲体验。同时我们持续优化视频编码算法，在保证画质的前提下将带宽占用降低了40%。",
  },
  {
    id: 3,
    question: "支持哪些设备观看？画质能达到什么水平？",
    answer: "黄桃视频全面支持PC网页端、手机浏览器和Pad平板设备。视频画质从流畅480P到超清4K HDR共六个档位可选，系统会根据您的网络带宽和设备屏幕自动推荐最佳画质。最新上线的影片全部提供4K版本，配合HDR显示设备可获得影院级视觉体验。",
  },
  {
    id: 4,
    question: "如何向黄桃视频投稿或反馈问题？",
    answer: "您可以通过页面上的「投稿与合作」板块联系我们。内容创作者可以提交自己的影视作品进行分发，我们提供完善的数据分析和收益系统。观影过程中如遇到任何问题，也可以通过同一渠道反馈，我们的技术团队通常在工作日24小时内响应处理。",
  },
];

export const updateItems = [
  { id: 1, date: "2026-07-31", title: "《哪吒之魔童闹海》4K修复版上线", type: "上架" },
  { id: 2, date: "2026-07-30", title: "黄桃视频日活跃用户突破8000万", type: "里程碑" },
  { id: 3, date: "2026-07-29", title: "播放引擎v3.2发布：HDR色彩增强", type: "更新" },
  { id: 4, date: "2026-07-28", title: "暑期档专题「仲夏光影」正式上线", type: "专题" },
  { id: 5, date: "2026-07-26", title: "CDN节点扩容至东南亚五国", type: "基建" },
  { id: 6, date: "2026-07-24", title: "与博纳影业达成战略内容合作", type: "合作" },
  { id: 7, date: "2026-07-22", title: "iOS与安卓PWA版本同步更新上线", type: "更新" },
  { id: 8, date: "2026-07-20", title: "用户安全中心升级：新增隐私保护模式", type: "安全" },
];

export const commentItems = [
  {
    id: 1,
    author: "影迷小王子",
    avatar: "https://readdy.ai/api/search-image?query=default%20user%20avatar%20silhouette%20with%20warm%20orange%20background%2C%20minimalist%20style%2C%20clean%20design&width=80&height=80&seq=avatar-ht-01&orientation=squarish",
    date: "3小时前",
    content: "之前一直在用别的平台看，朋友推荐了黄桃视频之后真的回不去了！4K画质太清晰了，而且真的不卡，我家的百兆宽带看别的平台偶尔会缓冲，黄桃视频完全不会。",
    rating: 5,
  },
  {
    id: 2,
    author: "剧荒终结者",
    avatar: "https://readdy.ai/api/search-image?query=default%20user%20avatar%20silhouette%20with%20warm%20coral%20background%2C%20minimalist%20style%2C%20clean%20design&width=80&height=80&seq=avatar-ht-02&orientation=squarish",
    date: "昨天",
    content: "片库是真的全！最近在追的几部新剧这里第一时间就能看到高清版，不用到处找了。画质在线播放的流畅度也让人惊喜，深夜看片完全不缓冲。",
    rating: 5,
  },
  {
    id: 3,
    author: "深夜观影人",
    avatar: "https://readdy.ai/api/search-image?query=default%20user%20avatar%20silhouette%20with%20warm%20teal%20background%2C%20minimalist%20style%2C%20clean%20design&width=80&height=80&seq=avatar-ht-03&orientation=squarish",
    date: "2天前",
    content: "用了大概一个月了，最大的感受就是稳定。以前用91视频和97视频经常晚上高峰时段卡顿，黄桃视频这点做得真心好，晚高峰照样流畅播放无压力。",
    rating: 5,
  },
  {
    id: 4,
    author: "电影发烧友阿杰",
    avatar: "https://readdy.ai/api/search-image?query=default%20user%20avatar%20silhouette%20with%20warm%20amber%20background%2C%20minimalist%20style%2C%20clean%20design&width=80&height=80&seq=avatar-ht-04&orientation=squarish",
    date: "3天前",
    content: "作为一个强迫症，我特别在意字幕质量和画面比例。黄桃视频的字幕翻译用心，画面也不会被裁切拉伸。最近上的《流浪地球3》4K版本简直视觉盛宴。",
    rating: 5,
  },
];

export const aboutInfo = {
  title: "关于黄桃视频",
  description: "黄桃视频诞生于2025年，由一群热爱影视的技术极客与内容创作者共同创立。我们深知国内用户对高清在线播放体验的渴望——不再忍受无休止的缓冲、模糊的画质和混乱的广告。黄桃视频从第一天起就确立了「不缓冲、不卡顿、极速高清」的产品理念，自研播放引擎与智能CDN分发系统，致力于为广大影视爱好者提供媲美91视频与97视频品质的一站式在线观影平台。\n\n我们的内容团队涵盖电影、电视剧、综艺、动漫、纪录片等全品类，每日更新超过200部优质内容。平台目前已累计服务超过8000万用户，播放总时长突破500亿小时。未来，黄桃视频将继续深耕内容生态与技术体验，让每一位用户都能随时随地畅享高清视界。",
  stats: [
    { value: "8000万+", label: "用户信赖" },
    { value: "200+", label: "每日更新" },
    { value: "500亿", label: "播放总时长(小时)" },
    { value: "10万+", label: "片源覆盖" },
  ],
};

export const appInfo = {
  title: "随时随地 · 流畅观影",
  description: "黄桃视频全面支持手机浏览器访问，无需下载APP即可享受高清流畅播放。将黄桃视频添加到手机桌面，即可获得类APP使用体验，随时随地畅享高清视界。",
  features: [
    "无需安装 · 即开即看",
    "流量优化 · 省流高清",
    "桌面快捷 · 一键直达",
    "画质自适应 · 智能切换",
  ],
  image: "https://readdy.ai/api/search-image?query=modern%20smartphone%20displaying%20video%20streaming%20interface%20with%20movie%20thumbnails%2C%20dark%20theme%20app%20design%2C%20warm%20orange%20accent%2C%20clean%20minimalist%20UI%2C%20product%20photography&width=500&height=400&seq=app-ht-01&orientation=portrait",
};

export const carouselItems = [
  {
    id: 1,
    title: "仲夏光影 · 暑期档特别策划",
    description: "精选今夏最值得观看的30部华语电影，从动作大片到文艺佳作，从经典修复到全新独播，每晚一部好片不重样。",
    tag: "热门专题",
    image: "https://readdy.ai/api/search-image?query=summer%20cinema%20theme%20with%20warm%20sunset%20colors%20and%20film%20reel%20elements%2C%20creative%20composition%2C%20artistic%20movie%20poster%20collage%2C%20rich%20golden%20and%20coral%20tones&width=700&height=400&seq=carousel-ht-01&orientation=landscape",
  },
  {
    id: 2,
    title: "4K修复计划 · 经典重生",
    description: "我们正在逐帧修复百部华语经典影片，运用AI超分辨率技术将老片提升至4K画质，让经典在新时代焕发新生。",
    tag: "技术专题",
    image: "https://readdy.ai/api/search-image?query=classic%20film%20restoration%20concept%20with%20old%20movie%20film%20strip%20transforming%20into%20modern%20digital%20pixels%2C%20warm%20vintage%20to%20modern%20transition%2C%20cinematic%20lighting&width=700&height=400&seq=carousel-ht-02&orientation=landscape",
  },
  {
    id: 3,
    title: "导演大师课 · 王家卫作品全回顾",
    description: "从《旺角卡门》到《繁花》，完整回顾王家卫导演三十余年创作轨迹，深度解析其独特视觉美学与叙事风格。",
    tag: "影人专题",
    image: "https://readdy.ai/api/search-image?query=artistic%20director%20chair%20in%20spotlight%20on%20empty%20film%20set%2C%20cinematic%20atmosphere%20with%20smoke%20and%20warm%20lighting%2C%20mysterious%20and%20elegant%20film%20production%20aesthetic&width=700&height=400&seq=carousel-ht-03&orientation=landscape",
  },
  {
    id: 4,
    title: "新片速递 · 八月观影指南",
    description: "独家整理八月即将上线的院线新片与平台独播内容，包含动作、喜剧、悬疑、科幻等多元类型，提前锁定你的观影清单。",
    tag: "前瞻专题",
    image: "https://readdy.ai/api/search-image?query=movie%20theater%20interior%20with%20empty%20red%20seats%20and%20bright%20screen%20glow%2C%20anticipation%20atmosphere%2C%20warm%20ambient%20lighting%2C%20cinematic%20experience%20setting&width=700&height=400&seq=carousel-ht-04&orientation=landscape",
  },
];

export const rankingItems = [
  { id: 1, rank: 1, title: "流浪地球3", category: "科幻", heat: "本周热度 9.8", trend: "up" },
  { id: 2, rank: 2, title: "繁花（导演剪辑版）", category: "剧情", heat: "本周热度 9.6", trend: "up" },
  { id: 3, rank: 3, title: "歌手2026 总决赛", category: "综艺", heat: "本周热度 9.4", trend: "up" },
  { id: 4, rank: 4, title: "逆袭人生", category: "喜剧", heat: "本周热度 9.1", trend: "new" },
  { id: 5, rank: 5, title: "哪吒之魔童闹海", category: "动画", heat: "本周热度 8.9", trend: "up" },
];

export const indexItems = [
  { id: 1, title: "动作大片", count: "128部", icon: "ri-fire-line" },
  { id: 2, title: "喜剧天堂", count: "96部", icon: "ri-emotion-laugh-line" },
  { id: 3, title: "悬疑推理", count: "84部", icon: "ri-search-eye-line" },
  { id: 4, title: "科幻世界", count: "72部", icon: "ri-rocket-line" },
  { id: 5, title: "文艺佳作", count: "65部", icon: "ri-quill-pen-line" },
  { id: 6, title: "纪录片库", count: "156部", icon: "ri-film-line" },
  { id: 7, title: "动漫番剧", count: "230部", icon: "ri-ghost-line" },
  { id: 8, title: "综艺合集", count: "89部", icon: "ri-tv-line" },
  { id: 9, title: "4K专区", count: "310部", icon: "ri-4k-line" },
];

export const featureItems = [
  {
    id: 1,
    icon: "ri-flashlight-line",
    title: "极速加载",
    description: "自研AI预加载引擎，智能缓存下一片段，4K视频也能做到即点即播，告别缓冲焦虑。",
  },
  {
    id: 2,
    icon: "ri-shield-check-line",
    title: "安全纯净",
    description: "全站无恶意广告弹窗，无强制注册，无需下载任何软件。纯净观影环境，保护您的隐私安全。",
  },
  {
    id: 3,
    icon: "ri-device-line",
    title: "多端适配",
    description: "PC、手机、平板完美适配，智能画质切换。无论在家还是出行，高清流畅始终如一。",
  },
];